import * as styles from "./BusyAreas.module.css";

import React from "react";

/**
 * BusyAreas component with title and list of the busiest areas
 *
 * @param {string} title The title of the component
 * @param {string[]} busiestAreas An array of strings representing the busiest areas
 * @returns {React.ReactElement} The component
 */
const BusyAreas = ({
  title,
  busiestAreas,
}: {
  title: string;
  busiestAreas: string[];
}) => {
  return (
    <section className={`inner ${styles.obaContainer}`}>
      <h2>{title}</h2>
      <div className={styles.obaContainerInner}>
        {busiestAreas.map((a, i) => {
          return <span key={`span_oba_${i}`}>{a}</span>;
        })}
      </div>
    </section>
  );
};

export default BusyAreas;
